import { render, staticRenderFns } from "./KeepInTouch2.vue?vue&type=template&id=0a4b3177&scoped=true&"
import script from "./KeepInTouch2.vue?vue&type=script&lang=js&"
export * from "./KeepInTouch2.vue?vue&type=script&lang=js&"
import style0 from "./KeepInTouch2.vue?vue&type=style&index=0&id=0a4b3177&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b3177",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
